<template>
  <div>
    <EditableArea
      v-if="atMagnoliaEditor"
      :content="header"
    />
    <div
      id="home"
      class="mx-auto my-10 text-neutral-900 md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl mobile:my-3"
    >
      <EditableArea
        v-if="area1"
        :content="area1"
      />
    </div>
    <EditableArea
      v-if="atMagnoliaEditor"
      :content="prefooter"
    />
    <EditableArea
      v-if="atMagnoliaEditor"
      :content="footer"
    />
  </div>
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor/dist/vue-editor.es.js';
import { useMagnolia } from '~/composables/custom/useMagnolia/useMagnolia';
import type HomePage from '~/templates/pages/HomePage/HomePage.model';

const {
  header = () => ({}),
  area1 = () => ({}),
  prefooter = () => ({}),
  footer = () => ({}),
} = defineProps<HomePage>();

const { atMagnoliaEditor } = useMagnolia();
</script>
